import { render, staticRenderFns } from "./TalkNotify.vue?vue&type=template&id=d105e6ce&scoped=true"
import script from "./TalkNotify.vue?vue&type=script&lang=js"
export * from "./TalkNotify.vue?vue&type=script&lang=js"
import style0 from "./TalkNotify.vue?vue&type=style&index=0&id=d105e6ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d105e6ce",
  null
  
)

export default component.exports